function secondMenu() {
	$('.second-menu .parent-element').on('click', function () {

		$(this).toggleClass('active');
		$('i').toggleClass('active');
		$('.dropdown-second-menu').toggleClass('active');

	});

}

function accordion() {
	$('.link-accordion').on('click', function () {
		$(this).toggleClass('active');
		$(this).next('.content-accordion').toggleClass('active');
	});
	$('#reset-filtri').on('click', function () {
		$('.list-tag button.active').not(':first').removeClass('active');
		$('.list-tag button.active').trigger('click');
		return false;
	});
}

function mobileAccordion() {

	if (screen.width < 768) {
		$('.content-accordion').removeClass('active');
	}

}

function slideLezioni() {
	if ($('.slide-video-lezioni .item').length > 1) {
		$('.slide-video-lezioni').slick({
			arrows: true,
			prevArrow: "<button type='button' class='prev-ep pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i> EP PRECEDENTE</button>",
			nextArrow: "<button type='button' class='next-ep pull-right'>EP SUCCESSIVO <i class='fa fa-angle-right' aria-hidden='true'></i></button>",
			dots: false,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						prevArrow: "<button type='button' class='prev-ep pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
						nextArrow: "<button type='button' class='next-ep pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}
}

/*----------------------------------------------------------
 *  Main nav
 *--------------------------------------------------------*/
function mainNav() {

	$(".ui-menu-item").hover(function () {
		/*
		Hover alows a mouseenter and mouse leave event
		seperated by a comma
		*/
		$(this).children('.ui-menu').addClass("active");

		//Event one mouse enter add class
		$("#graph").addClass("hoverstate");
	},
		// Event two mouse out remove class
		function () {
			$("#graph").removeClass("hoverstate");
			$(this).children('.ui-menu').removeClass("active");
		});

	const mainNav = document.querySelector('.main-nav');

	// Ancore che aprono un sottomenu su mobile
	var dropdownTogglers = $('.main-nav a').filter(function (i, e) {
		return $(e).next().is('ul') || $(e).next().is('.dropdown-menu');
	});

	dropdownTogglers.addClass('dropdown-toggler');


	// Menu Desktop
	var menuDesktop = {
		active: false,
		init: function () {
			var self = this;



			$('.main-nav .nav-link').on('mouseenter', function () {
				if (self.active) {
					$('.main-nav .dropdown-menu .menu')
						.css('height', 'auto')
						.menu("collapseAll", null, true)
						;
				}
			}
			);


			dropdownTogglers.click(function (ev) {
				ev.preventDefault();
			})

			$(".dropdown-menu .menu").menu({
				classes: {
					"ui-menu": "highlight"
				},
				position: {
					my: "left top",
					at: "right top"
				},
				blur: function (event, ui) {

				},
				focus: function (event, ui) {

					var el = ui.item,
						$parent = $(el).parents('.menu'),
						$child = $(el).find('.ui-menu'),
						maxH = 0
						;

					if ($child.height()) {
						$child.height() >= $parent.height() ? $parent.height($child.height() + 'px') : $parent.height('auto');
					}
				}
			});
		}
	};


	// Menu mobile
	var menuMobile = {
		init: function () {
			dropdownTogglers
				.each(function (i, e) {
					$(e).on('click', function (ev) {
						ev.preventDefault();
						ev.stopImmediatePropagation();
						$(e)
							.toggleClass('open')
							.next()
							.stop()
							.slideToggle('slow')
							;
					});
				})
				;
		},
		destroy: function () {
			dropdownTogglers
				.each(function (i, e) {
					$(e).off('click');
				})
				;
		}
	};


	function checkWidth() {
		if (window.matchMedia('(min-width: 992px)').matches) {
			$('.main-nav > .navbar').addClass('fixed-top');
			if (!menuDesktop.active) {
				menuMobile.destroy();
				menuDesktop.init();
				menuDesktop.active = true;
			}
		} else {
			$('.main-nav > .navbar').removeClass('fixed-top');

			if (menuDesktop.active) {
				$(".dropdown-menu .menu").menu('destroy');
				menuDesktop.active = false;
			}

			menuMobile.init();
		}
	}

	function checkScroll() {
		// alert(1);
		$(window).scrollTop() > 0 ? mainNav.classList.add('main-nav--scrolled') : mainNav.classList.remove('main-nav--scrolled');
	}



	// Ricerca
	$('.main-nav__search .btn')
		.hover(
			function () {
				$('.main-nav__search').addClass('main-nav__search--open');
			},
			function () {
				$('.main-nav__search').removeClass('main-nav__search--open');
			}
		)
		.click(function () {
			if (!$('.main-nav__search').hasClass('main-nav__search--open')) {
				$('.main-nav__search').addClass('main-nav__search--open');
			} else if ($('.main-nav__search input').val() === '') {
				return false;
			}
		})
		;
	$('.main-nav__search input')
		.on('focus', function () { this.placeholder = ''; })
		.on('blur', function () { this.placeholder = this.getAttribute('aria-label'); })
		;

	dropdownTogglers.click(function (ev) { ev.preventDefault(); });



}

/* --------------------------------------------------
  menuMobile
-------------------------------------------------- */
function mnMobile() {

	var isMobile = {
		Android: function () {
			return navigator.userAgent.match(/Android/i);
		},
		BlackBerry: function () {
			return navigator.userAgent.match(/BlackBerry/i);
		},
		iOS: function () {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		},
		Opera: function () {
			return navigator.userAgent.match(/Opera Mini/i);
		},
		Windows: function () {
			return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
		},
		any: function () {
			return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
		}
	};

	if (isMobile.iOS()) $('.mn-mb').css({ "padding-bottom": "130px" });
	if (isMobile.iOS()) $('.lv-2').css({ "padding-bottom": "130px" });
	if (isMobile.iOS()) $('.lv-3').css({ "padding-bottom": "130px" });

	var menu = $('.mn-mb');
	var Lv1 = $('.lv-1');
	var Lv2 = $('.lv-2');
	var Lv3 = $('.lv-3');
	var itemLv1 = $('.item-lv-1');
	var itemLv2 = $('.item-lv-2 a');

	$('.navbar-toggler').on('click', function () {
		$(this).toggleClass('collapsed');
		$('html, body').toggleClass('no-scroll');
		$('.main-nav .navbar .container-fluid').toggleClass('scroll');
		$('.collapse').toggleClass('show');
		if ($(this).hasClass('collapsed')) {
			$(Lv2).hide();
		}
	})


	$(Lv1).click(function () {
		$(this).next(Lv2).show();
		$('html, body').addClass('no-scroll');
		//$('.main-nav .navbar .container-fluid').removeClass('scroll');
	});

	$('.back-lv-1').click(function () {
		$(this).parent(Lv2).hide();
		$('.main-nav .navbar .container-fluid').addClass('scroll');
	});

	$(itemLv2).click(function () {
		$(this).next(Lv3).show();
		$(Lv2).css({ "overflow": "hidden" });
	});

	$('.back-lv-2').click(function () {
		$(this).parent(Lv3).hide();
		$(Lv2).css({ "overflow": "auto" });
	});

	$("#iq1").focus(function () {
		$(this).next('.input-group-btn').toggleClass("blue");

	}).blur(function () {
		$(this).next('.input-group-btn').toggleClass("blue");
	})

	$(window).on("orientationchange", function (event) {
		$('html, body').removeClass('no-scroll');
		$(Lv2).hide();
		$(Lv3).hide();
	});
}

function selectCustom() {
	$('.custom-select').select2();
}

function catMobile() {
	$('.link-cat-mobile').on('click', function () {
		$('.menu-cat-mobile').addClass('active');
		$('.submenu-item-menu').removeClass('active');
		$('body').addClass('no-scroll');
	})
	$('.head .close-icon').on('click', function () {
		$('.menu-cat-mobile').removeClass('active');
		$('.submenu-item-menu').addClass('active');
		$('body').removeClass('no-scroll');
	})
}

function onClickTagBtn() {
	$('.tag-link').on('click', function () {
		var href = $(this).val();
		try {
			var url = new URL(href);
			document.location.href = href;
		} catch (error) {
			return false;
		}
	});
}

function menuGlossario() {
	$('.lettere-dizionario a').on('click', function (e) {
		// e.preventDefault();

		var target = this.hash,
			$target = $(target);

		$('html, body').stop().animate({
			'scrollTop': $target.offset().top - 100
		}, 500, 'swing', function () {
		});

		//console.log(window.location);

		$(".list-lettere").find(".box-lettera").removeClass("active");
		$(".list-lettere").find($target).parent(".box-lettera").addClass("active");

		return false;
	});

	$(".list-lettere-m select").change(function () {
		var target = this.value,
			$target = $(target);

		$('html, body').animate({
			'scrollTop': $target.offset().top - 150
		}, 100, 'swing', function () {
		});

		$(".list-lettere").find(".box-lettera").removeClass("active");
		$(".list-lettere").find($target).parent(".box-lettera").addClass("active");

	});


}

function loadMore() {
	$('#load_more').on('click', function () {
		var endpoint = $('input[name=next_page]').val();
		if (endpoint) {
			try {
				var url = new URL(endpoint);
				$.getJSON(endpoint, function (data, status) {
					if (status == "success") {
						var content = '';
						data.forEach(function (post) {
							switch (post['ext_categories'][0]['slug']) {
								case "guide":
									var icon = "icon-2.png";
									break;
								case "media":
									var icon = "icon-3.png";
									break;
								default:
									var icon = "icon-1.png";
							}
							content +=
								'<div class="col-12 col-md-4">' +
								'	<div class="item">' +
								'		<a href="' + post['link'] + '"> ' +
								'			<div class="categoria">' +
								'				<span>';
							content += post['ext_categories'].map(function (cat) {
								return cat['name'];
							}).join(', ');
							const baseUrl = window.location.origin;
							const apiIcon = `${baseUrl}/magazine/contrib/themes/tsmagazine-theme/client/docs/img`;
							content +=
								'				</span>' +
								'				<img src="' + apiIcon + '/' + icon + '" alt="">' +
								'			</div>' +
								'			<div class="title">' + post['title']['rendered'] + '</div>' +
								'			<div class="text">' + post['excerpt']['rendered'] + '</div>' +
								'		</a>' +
								'		<div class="meta"><span class="data">' + post['date_formatted'] + '</span> | ';
							if ('autore' in post['acf'] && typeof post['acf']['autore'] == 'object') {
								content += post['acf']['autore'].map(function (auth) {
									return '<a class="item-author" href="' + auth['url'] + '"> ' + auth['titolo'] + '</a>';
								}).join(', ');
							}
							content +=
								'		</div>' +
								'	</div>' +
								'</div> ';
						});
						$('.section--all-post .riga').append(content);
						if (endpoint.indexOf("&page=") !== -1) {
							//if (navigator.userAgent.indexOf("Mac OS") !== -1) {
							var page = endpoint.substring(endpoint.indexOf('?') + 1).split('&').find(function (el) {
								return el.startsWith("page");
							}).split('=')[1];
							if (page.length > 0 && page != '' && parseInt(page) < parseInt($('input[name=next_page]').attr('data-pages'))) {
								endpoint = endpoint.replace(/&page=\d+/, "&page=" + (parseInt(page) + 1));
								$('input[name=next_page]').val(endpoint);
							} else {
								$('#load_more').remove();
							}
							//} else {
							//	var page = endpoint.match(/(?<=(&page=))\d+/);
							//	if (page.length > 0 && page[0] != '' && parseInt(page[0]) < parseInt($('input[name=next_page]').attr('data-pages'))) {
							//		endpoint = endpoint.replace(/(?<=(&page=))\d+/, parseInt(page[0]) + 1);
							//		$('input[name=next_page]').val(endpoint);
							//	} else {
							//		$('#load_more').remove();
							//	}
							//}
						} else {
							$('#load_more').remove();
						}
					}
				});
			} catch (error) {
				return false;
			}
		}
		return false;
	});
}

/*--------------------------------------------------
 Back to top
--------------------------------------------------*/
function backtotop() {
	var $backtotop = $('.backtotop');

	$backtotop.click(function () {
		$('html, body').animate({ scrollTop: 0 });
	});

	var checkScroll = _.throttle(function () {
		window.scrollY > window.innerHeight ? $backtotop.addClass('visible') : $backtotop.removeClass('visible');
	}, 1000);

	$(window).scroll(checkScroll);
}

/*--------------------------------------------------
Header searc
--------------------------------------------------*/
function headerSearch() {
	$('.header__search').on('click', function () {
		$('.submenu-item-menu form').toggleClass('active');
	});

}

function filter() {
	$('.list-tag button').on('click', function () {
		$('.load-filter').show();
		$(this).toggleClass('active');
		var filtri = [];
		$('.list-tag button.active').each(function () {
			filtri.push($(this).attr('data-filter'));
		});
		params["filtri"] = filtri;
		var qsfiltri = filtri.length > 0 ? '&filtri=' + filtri.join(',') : '';
		var endpoint = params["wp_posts_endpoint"] + '?categories=' + params["categories"] + qsfiltri + '&per_page=' + params['posts_per_page'] + '&page=1';
		filtri = [];
		$('.list-tag button.active').each(function () {
			if (!($(this).attr("data-parent") in filtri))
				filtri[$(this).attr("data-parent")] = [];
			filtri[$(this).attr("data-parent")].push($(this).val());
		});
		// aggiornamento contenuti filtrati
		try {
			var url = new URL(endpoint);
			$.getJSON(endpoint, function (data, status) {
				if (status == "success") {
					$('.section--ultime-news .item-cont').remove();
					var content = '';
					if (data.length == 0) {
						content += '<div class="col-12 item-cont">Nessun risultato per la ricerca selezionata, prova a estendere la ricerca.</div>';
					} else {
						data.forEach(function (post) {
							switch (post['ext_categories'][0]['slug']) {
								case "guide":
									var icon = "icon-2.png";
									break;
								case "media":
									var icon = "icon-3.png";
									break;
								default:
									var icon = "icon-1.png";
							}
							content +=
								'<div class="col-12 col-md-3 item-cont">' +
								'	<div class="item">' +
								'		<a href="' + post['link'] + '"> ' +
								'		<div class="img" >' +
								(post['thumbnail'] != '' ? '<img src="' + post['thumbnail'] + '" alt="' + post['title']['rendered'] + '">' : '') +
								'		</div>' +
								'			<div class="categoria">' +
								'				<span>';
							content += post['ext_categories'].map(function (cat) {
								return cat['name'];
							}).join(', ');
							const baseUrl = window.location.origin;
							const apiIcon = `${baseUrl}/magazine/contrib/themes/tsmagazine-theme/client/docs/img`;
							content +=
								'				</span>' +
								'				<img src="' + apiIcon + '/' + icon + '" alt="">' +
								'			</div>' +
								'			<div class="title">' + post['title']['rendered'] + '</div>' +
								'			<div class="text">' + post['excerpt']['rendered'] + '</div>' +
								'		</a>' +
								'		<div class="meta"><span class="data">' + post['date_formatted'] + '</span> | ';
							if ('autore' in post['acf']) {
								content += post['acf']['autore'].map(function (auth) {
									return '<a class="item-author" href="' + auth['url'] + '"> ' + auth['titolo'] + '</a>';
								}).join(', ');
							}
							content +=
								'		</div>' +
								'	</div>' +
								'</div> ';
						});
					}
					$('.section--ultime-news .row.items').append(content);
				}

				// aggiornamento url pagina
				var url = params["base_cat_href"];
				var qs = Object.keys(filtri).map(function (k) {
					return k + '=' + filtri[k];
				}).join('&');
				if (qs != '') url += '?' + qs;
				window.history.replaceState('filtered-page', '', url);
			});
		} catch (error) {
			return false;
		}

		endpoint = params["wp_countposts_endpoint"] + '?categories=' + params["categories"] + qsfiltri;
		try {
			var url = new URL(endpoint);
			$.getJSON(endpoint, function (data, status) {
				// aggiornamento paginazione
				if (status == "success") {
					$('.section--pagination').remove();
					var content = '';
					if (Math.ceil(data["found_posts"] / params["posts_per_page"]) > 1) {
						var qs = Object.keys(filtri).map(function (k) {
							return k + '=' + filtri[k];
						}).join('&');
						content +=
							'<section class="section--pagination json--pagination">' +
							'	<div class="row">' +
							'		<div class="col-12">' +
							'			<div class="pagination">' +
							'				<ul>' +
							'					<li>' +
							'						<a class="active" href="#" data-val="1">' + 1 + '</a>' +
							'					</li>';
						for (var i = 2; i <= Math.ceil(data["found_posts"] / params["posts_per_page"]) && i <= 5; i++) {
							content +=
								'				<li>' +
								'					<a href="' + params["base_cat_href"] + 'pagina/' + i + '/' + (qs != '' ? '?' + qs : '') + '" data-val="' + i + '">' + i + '</a>' +
								'				</li>';
						}
						content +=
							'					<li>' +
							'						<a href="' + params["base_cat_href"] + 'pagina/2/' + (qs != '' ? '?' + qs : '') + '" data-val="next">' +
							'							<i class="fa fa-angle-right"></i>' +
							'						</a>' +
							'					</li>';
						content +=
							'				</ul>' +
							'			</div>' +
							'		</div>' +
							'	</div>' +
							'</section>';
					}
					$('.section--ultime-news').after(content);
				}
				$('html, body').animate({ 'scrollTop': $('.items').offset().top });
				$('.load-filter').hide();
				if (params["filtri"].length) {
					$('#reset-filtri').show();
				} else {
					$('#reset-filtri').hide();
				}
			});
		} catch (error) {
			$('.load-filter').hide();
			if (params["filtri"].length) {
				$('#reset-filtri').show();
			} else {
				$('#reset-filtri').hide();
			}
			return false;
		}
		return false;
	});
}

function paginate() {
	$('body').on('click', '.json--pagination a', function () {
		$('.load-filter').show();
		var filtri = [];
		$('.list-tag button.active').each(function () {
			filtri.push($(this).attr('data-filter'));
		});
		params["filtri"] = filtri;
		var qsfiltri = filtri.length > 0 ? '&filtri=' + filtri.join(',') : '';
		var endpoint = params["wp_posts_endpoint"] + '?categories=' + params["categories"] + qsfiltri + '&per_page=' + params['posts_per_page'];
		var page = 1;
		switch ($(this).attr("data-val")) {
			case "prev":
				page = parseInt($('.json--pagination a.active').attr("data-val")) - 1;
				endpoint += '&page=' + page;
				break;
			case "next":
				page = parseInt($('.json--pagination a.active').attr("data-val")) + 1;
				endpoint += '&page=' + page;
				break;
			default:
				page = parseInt($(this).attr("data-val"));
				endpoint += '&page=' + page;
		}
		var href = $(this).attr("href");
		// aggiornamento contenuti filtrati
		try {
			var url = new URL(endpoint);
			$.getJSON(endpoint, function (data, status) {
				if (status == "success") {
					$('.section--ultime-news .item-cont').remove();
					var content = '';
					if (data.length == 0) {
						content += '<div class="col-12 item-cont">Nessun risultato per la ricerca selezionata, prova a estendere la ricerca.</div>';
					} else {
						data.forEach(function (post) {
							switch (post['ext_categories'][0]['slug']) {
								case "guide":
									var icon = "icon-2.png";
									break;
								case "media":
									var icon = "icon-3.png";
									break;
								default:
									var icon = "icon-1.png";
							}
							content +=
								'<div class="col-12 col-md-3 item-cont">' +
								'	<div class="item">' +
								'		<a href="' + post['link'] + '"> ' +
								'			<div class="img" >' +
								(post['thumbnail'] != '' ? '<img src="' + post['thumbnail'] + '" alt="' + post['title']['rendered'] + '">' : '') +
								'			</div>' +
								'			<div class="categoria">' +
								'				<span>';
							content += post['ext_categories'].map(function (cat) {
								return cat['name'];
							}).join(', ');
							const baseUrl = window.location.origin;
							const apiIcon = `${baseUrl}/magazine/contrib/themes/tsmagazine-theme/client/docs/img`;
							content +=
								'				</span>' +
								'				<img src="' + apiIcon + '/' + icon + '" alt="">' +
								'			</div>' +
								'			<div class="title">' + post['title']['rendered'] + '</div>' +
								'			<div class="text">' + post['excerpt']['rendered'] + '</div>' +
								'		</a>' +
								'		<div class="meta"><span class="data">' + post['date_formatted'] + '</span> | ';
							if ('autore' in post['acf']) {
								content += post['acf']['autore'].map(function (auth) {
									return '<a class="item-author" href="' + auth['url'] + '"> ' + auth['titolo'] + '</a>';
								}).join(', ');
							}
							content +=
								'		</div>' +
								'	</div>' +
								'</div> ';
						});
					}
					$('.section--ultime-news .row.items').append(content);
				}
				// aggiornamento url pagina
				window.history.replaceState('filtered-page', '', href);
			});
		} catch (error) {
			return false;
		}
		var filtri = [];
		$('.list-tag button.active').each(function () {
			filtri.push($(this).attr('data-filter'));
		});
		var qsfiltri = filtri.length > 0 ? '&filtri=' + filtri.join(',') : '';
		filtri = [];
		$('.list-tag button.active').each(function () {
			if (!($(this).attr("data-parent") in filtri))
				filtri[$(this).attr("data-parent")] = [];
			filtri[$(this).attr("data-parent")].push($(this).val());
		});
		endpoint = params["wp_countposts_endpoint"] + '?categories=' + params["categories"] + qsfiltri;
		try {
			var url = new URL(endpoint);
			$.getJSON(endpoint, function (data, status) {
				// aggiornamento paginazione
				if (status == "success") {
					$('.section--pagination').remove();
					var content = '';
					if (Math.ceil(data["found_posts"] / params["posts_per_page"]) > 1) {
						var qs = Object.keys(filtri).map(function (k) {
							return k + '=' + filtri[k];
						}).join('&');
						content +=
							'<section class="section--pagination json--pagination">' +
							'	<div class="row">' +
							'		<div class="col-12">' +
							'			<div class="pagination">' +
							'				<ul>';
						if (page > 1) {
							content +=
								'				<li>' +
								'					<a href="' + params["base_cat_href"] + (page - 1 > 1 ? 'pagina/' + (page - 1) + '/' : '') + (qs != '' ? '?' + qs : '') + '" data-val="prev">' +
								'						<i class="fa fa-angle-left"></i>' +
								'					</a>' +
								'				</li>';
						}
						for (var i = 1; i <= Math.ceil(data["found_posts"] / params["posts_per_page"]) && i <= 20; i++) {
							if (i == page) {
								content +=
									'			<li>' +
									'				<a class="active" href="#" data-val="' + i + '">' + i + '</a>' +
									'			</li>';
							} else {
								content +=
									'			<li>' +
									'				<a href="' + params["base_cat_href"] + (i > 1 ? 'pagina/' + i + '/' : '') + (qs != '' ? '?' + qs : '') + '" data-val="' + i + '">' + i + '</a>' +
									'			</li>';
							}
						}
						if (page < Math.ceil(data["found_posts"] / params["posts_per_page"])) {
							content +=
								'				<li>' +
								'					<a href="' + params["base_cat_href"] + 'pagina/' + (page + 1) + '/' + (qs != '' ? '?' + qs : '') + '" data-val="next">' +
								'						<i class="fa fa-angle-right"></i>' +
								'					</a>' +
								'				</li>';
						}
						content +=
							'				</ul>' +
							'			</div>' +
							'		</div>' +
							'	</div>' +
							'</section>';

					}
					$('.section--ultime-news').after(content);
				}
				$('html, body').animate({ 'scrollTop': $('.items').offset().top });
				$('.load-filter').hide();
			});
			return false;
		} catch (error) {
			$('.load-filter').hide();
			return false;
		}
	});
}

function clickBanner() {
	$('.magazine_bottom_cta').on('click', function () {
		window.dataLayer.push({
			'event': 'select_content',
			'content_type': 'magazine_bottom_cta'
		})
	});
	$('.magazine_article_banner').on('click', function () {
		window.dataLayer.push({
			'event': 'select_content',
			'content_type': 'magazine_article_banner'
		})
	});
	$('body').on('click', '.download_guide', function () {
		window.dataLayer.push({
			'event': 'select_content',
			'content_type': 'download_guide'
		})
	});
	$('.btn-contatti').on('click', function () {
		window.dataLayer.push({
			'event': 'select_content',
			'content_type': 'nav_contact_us'
		})
	});

	// $('.banner-adv-blog .cta .button, .banner-adv .cta .button, .banner .cta .button, .cta-prodotto .btn').on('click', function() {
	// 	window.dataLayer.push({
	// 		'event':'select_content',
	// 		'content_type':'magazine_sidebar'
	// 	})
	// });
}

// Header service
function headerService() {
	$('[data-service-toggle]').on('click', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			// $("body").removeClass('no-scroll');
		} else {
			$(this).addClass('active');
			// $("body").addClass('no-scroll');
		}
	});
}

// Indice articoli
function indiceArticoli() {
	const banner = document.querySelector('.banner--sticky');

	if (banner) {
		const adjustAnchorScroll = (event) => {
			// Evita il comportamento predefinito del link
			event.preventDefault();

			// Ottieni l'ancora di destinazione
			const targetId = event.target.getAttribute('href').slice(1);
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				const bannerHeight = banner.offsetHeight;

				// Calcola la posizione corretta della sezione
				const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

				// Scrolla aggiungendo un offset per il banner
				window.scrollTo({
					top: targetPosition - bannerHeight,
					behavior: 'smooth', // Scorrimento fluido
				});
			}
		};

		// Aggiungi l'evento click a tutti i link con ancore
		const anchorLinks = document.querySelectorAll('a[href^="#"]');
		anchorLinks.forEach((link) => {
			link.addEventListener('click', adjustAnchorScroll);
		});
	}
}

class SidebarMenu {
	constructor(node) {
		this.node = node;

		// Elementi relativi al menu laterale
		this.openSidebarBtn = document.getElementById("openSidebarBtn");
		this.closeSidebarBtn = document.getElementById("closeSidebarBtn");
		this.sidebar = document.getElementById("sidebarMenu");
		this.overlay = document.getElementById("overlay");

		this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
		this.firstFocusableElement = null;
		this.lastFocusableElement = null;

		this.initSidebar();
	}

	// Inizializza i listener per il menu laterale
	initSidebar() {
		if (this.openSidebarBtn && this.closeSidebarBtn && this.sidebar && this.overlay) {
			this.openSidebarBtn.addEventListener("click", this.openSidebar.bind(this));
			this.closeSidebarBtn.addEventListener("click", this.closeSidebar.bind(this));
			this.overlay.addEventListener("click", this.closeSidebar.bind(this));
		}
	}

	updateTabIndexes(enable) {
		const focusableContent = this.sidebar.querySelectorAll(this.focusableElements);
		focusableContent.forEach((element) => {
			element.setAttribute("tabindex", enable ? "0" : "-1");
		});
	}

	openSidebar() {
		this.sidebar.classList.add("active");
		this.overlay.classList.add("active");
		this.openSidebarBtn.setAttribute("aria-expanded", "true");

		this.updateTabIndexes(true); // Abilita il tabindex
		const focusableContent = this.sidebar.querySelectorAll(this.focusableElements);
		this.firstFocusableElement = focusableContent[0];
		this.lastFocusableElement = focusableContent[focusableContent.length - 1];
		this.firstFocusableElement.focus();

		document.addEventListener("keydown", this.trapFocus.bind(this));
		console.log('open-sidebar');
		$('body').addClass('no-scroll');
	}

	closeSidebar() {
		this.sidebar.classList.remove("active");
		this.overlay.classList.remove("active");
		this.openSidebarBtn.setAttribute("aria-expanded", "false");

		this.updateTabIndexes(false); // Disabilita il tabindex
		this.openSidebarBtn.focus();
		document.removeEventListener("keydown", this.trapFocus.bind(this));
		console.log('close-sidebar');
		$('body').removeClass('no-scroll');
	}

	trapFocus(e) {
		if (e.key === "Tab") {
			if (e.shiftKey) {
				if (document.activeElement === this.firstFocusableElement) {
					e.preventDefault();
					this.lastFocusableElement.focus();
				}
			} else {
				if (document.activeElement === this.lastFocusableElement) {
					e.preventDefault();
					this.firstFocusableElement.focus();
				}
			}
		}
		if (e.key === "Escape") {
			this.closeSidebar();
		}
	}
}

function sideBarMenu() {
	const sidebarMenu = new SidebarMenu(document.querySelector('.sidebar-menu'));
}

/* -------------------------------------
  DOC Ready
--------------------------------------*/
$(function () {
	secondMenu();
	mainNav();
	mnMobile();
	selectCustom();
	catMobile();
	onClickTagBtn();
	loadMore();
	filter();
	paginate();
	slideLezioni();
	accordion();
	mobileAccordion();
	menuGlossario();
	backtotop();
	clickBanner();
	headerService();
	headerSearch();
	indiceArticoli();
	sideBarMenu();
});

var lastScrollTop = 0;
$(window).scroll(function () {
	var currentScroll = $(this).scrollTop();
	// Verifica se lo scroll è verso l'alto o verso il basso
	if (currentScroll > lastScrollTop) {
		// Scroll verso il basso
		$('.submenu-item-menu').removeClass('scroll-up').addClass('scroll-down');
		$('.header__service--desktop').removeClass('scroll-up').addClass('scroll-down');
		$('.banner--sticky').removeClass('scroll-up').addClass('scroll-down');
		$('.sidebar').removeClass('scroll-up').addClass('scroll-down');
	} else {
		// Scroll verso l'alto
		if (currentScroll < 900) {
			$('.submenu-item-menu').removeClass('scroll-down').addClass('scroll-up');
			$('.header__service--desktop').removeClass('scroll-down').addClass('scroll-up');
			$('.banner--sticky').removeClass('scroll-down').addClass('scroll-up');
			$('.sidebar').removeClass('scroll-down').addClass('scroll-up');
		}
	}
	lastScrollTop = currentScroll;
});
